import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const DiorBoardPage = () => <CaseStudyPage project={getProjectBySlug('dior-board')} />;

export default DiorBoardPage;
